import React from 'react';
import AAutoComplete from '../../../views/pages/manage/common/form-fields-mui/AAutoComplete';
import CustomDatePickerV2 from '../../../views/pages/manage/common/commonComponents/CustomDatePicker-V2';
import styles from "../styles.module.scss";
import AButton from '../../../views/pages/manage/common/form-fields-mui/AButton';

const defaultContainerStyles = {
    display : 'grid',
    gap : '0.5rem'
}

const sampleFormFields = [
    {
        label: 'Academic Group',
        type: 'select',
        items: [],
        formKey: 'academicGroup',
        onChange: () => { },
        loading: false,
        isMulti: false,
        isShowCount : false,
        placeholder: "Select academic group",
        disabled : false

    },
    {
        label: 'Reg Date',
        type: 'date',
        items: [],
        formKey: 'regDate',
        onChange: () => { },
        loading: false,
        placeholder: "From",
        minDate: '',
        maxDate: '',
        disabled : false
    }
]

export const getInputField = (formField, formHandler, form, isBulkSearch) => {
    const { label, type, formKey, onChange = () => { }, placeholder , disabled} = formField;
    const formFieldsDisabled = !isBulkSearch || disabled;
    switch (type) {
        case 'select': {
            const { items, loading, isMulti, isShowCount } = formField;
            return (
                <AAutoComplete
                    key={formKey}
                    label={label}
                    items={items}
                    style={{control : {height : '40px', borderRadius : '4px'}}}
                    currentValue={form[formKey]}
                    handleChange={val => {
                        formHandler(formKey, val);
                        onChange(val)
                    }}
                    isMulti={isMulti}
                    isLoading={loading}
                    placeholder={placeholder}
                    isDisabled={formFieldsDisabled}
                    isShowCount={isShowCount}
                />
            )
        }
        case 'date': {
            const { minDate, maxDate } = formField;
            return (
                <div>
                <CustomDatePickerV2
                    key={formKey}
                    label={label}
                    value={form[formKey]}
                    handler={(index, date) => {
                        formHandler(formKey, date);
                        onChange(date);
                    }}
                    placeHolder={placeholder}
                    minDate={minDate}
                    maxDate={maxDate}
                    disabled={formFieldsDisabled}
                />
                </div>
            )
        }
    }

}

const BulkSearchForm = ({ 
    formFields, 
    formHandler, 
    form = {}, 
    customBulkSearchContainerStyles,
    searchBtnTxt,
    searchHandler,
    isBulkSearch,
    isSearchBtnDisabled
 }) => {

    console.log('form', form);

    return (
        <div style={{
            ...defaultContainerStyles,
            gridTemplateColumns : `repeat(${formFields.length + 1},  1fr)`,
            ...customBulkSearchContainerStyles
            }}>

            {formFields?.map(formField => getInputField(formField, formHandler, form, isBulkSearch))}

            <div className='d-flex justify-content-center align-items-center mt-4'>
            <AButton
            variant='primary_filled'
            onClick={() => searchHandler({...form, isBulk : true,filters:form})}
            disabled={!isBulkSearch || isSearchBtnDisabled}
            >
              {searchBtnTxt}
            </AButton>
            </div>

        </div>
    );
}

export default BulkSearchForm;